export default {
    // 管理员查看合同列表
    getAdminContractList: "/contract/getAdminContractList",
    // 创建项目和主合同
    saveContractProject: "/contract/saveProject",
    // 根据主合同id获取项目和主合同详情
    getContractDetail: "/contract/getContractDetail",
    // 维修工获取合同列表
    getVendorContractList: "/contract/getVendorContractList",
    // 根据propId获取合同项目
    getProjectList: "/contract/getProjectList",
    // 上传文件
    contractUploadFile: "/contract/uploadFile",
    // 根据文件地址删除文件
    delContractFile: "/contract/delContractFile",
    // 根据主合同id批量增加文件
    saveContractFile: "/contract/saveContractFile",
    // 管理员审批维修工提交的项目和主合同
    updateApprove: "/contract/updateApprove",
    // 管理员审批维修工提交的主合同
    delContract: "/contract/delContract",
    // 获取登录人相关的prop
    // getPropByAccount: "/contract/getPropByAccount",
    // 管理员修改项目和主合同
    updateContractProject: "/contract/updateContractProject",
    /**
     * 子合同
     */
    // 新增子合同或材料
    saveContractSub: "/contract/saveContractSub",
    // 获取子合同列表
    getSubList: "/contract/getSubList",
    // 管理员审批维修工申请的子合同或材料
    approveContractSub: "/contract/approveContractSub",
    // 根据子合同id获取子合同详情
    getSubDetail: "/contract/getSubDetail",
    // 管理员根据子合同id删除子合同
    delSub: "/contract/delSub",
    // 管理员修改审批通过的子合同
    updateSubContract: "/contract/updateSubContract",
    /**
     * 合同交易
     */
    // 新增合同交易
    saveContractRecord: "/contract/saveContractRecord",
    // 修改交易合同状态
    updateRecordStatus: "/contract/updateRecordStatus",
    // 维修工根据主合同id分页获取合同交易列表
    getVendorRecordList: "/contract/getVendorRecordList",
    // 管理员根据主合同id分页查看合同交易列表
    getAdminRecordList: "/contract/getAdminRecordList",
    // 老板根据主合同id分页获取需要审批的合同交易
    getRecordList: "/contract/getRecordList",
    // 根据合同交易id获取交易详情
    getRecordDetail: "/contract/getRecordDetail",
    // 维修工修改被拒绝的交易
    updateRecordContract: "/contract/updateRecordContract",
    // 获取账单
    getContractVendorPaymentList: "/contract/getContractVendorPaymentList",
        // 获取账单
    getOtherContractVendorPaymentList: "/contract/getOtherContractVendorPaymentList",
    // 批量同步删除账单
    sysDelPaymentToRecordBatch: "/contract/sysDelPaymentToRecordBatch",
    // 批量同步删除账单
    sysOtherDelPaymentToRecordBatch: "/contract/sysOtherDelPaymentToRecordBatch",
    // 管理员审批维修工提交的交易流转
    approveContractRecord: "/contract/approveContractRecord",
    // 根据主合同id查询所有已选中的账单
    getLinkPayment: "/contract/getLinkPayment",
    // 下载excel
    contractDownloadExcel: "/contract/downloadExcel",
    // 修改主合同状态
    updateContractStatus: "/contract/updateContractStatus",
    // 修改主合同时间
    updateContractDate: "/contract/updateContractDate",
    // 获取合同管理员
    contractSearchAccount: "/contract/searchAccount",
    searchMajorAccount: "/contract/searchMajorAccount",

    // MajorProjectAP
    // 管理员推送给老板的交易流转汇总
    contractGetRecordSummary: "/contract/getRecordSummary",
    // 修改交易流转记录
    contractUpdateApprovalRecord: "/contract/updateApprovalRecord",
    // 删除被拒绝的交易流转记录
    contractDelApprovalRecord: "/contract/delApprovalRecord",
    // 批量推送交易流转记录给老板
    contractApprovalBatchRecord: "/contract/approvalBatchRecord",

    // ApprovalSummary/CheckApproval 根据账单id和主合同id获取所有文件列表
    contractGetAllFile: "/contract/getAllFile",
    // ap request history 上传文件
    contractUploadFileForVendorPayment: "/contract/uploadFileForVendorPayment",
}